<template>
  <div id="login" class="login-main" v-loading="loading">
    <my-header></my-header>
    <!--登录start-->
    <div class="login-container">
      <div class="login-form">
        <el-form :model="loginForm" :rules="loginRules" ref="loginform" status-icon class="login-page">
          <p class="login-title">登录</p>
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              type="text"
              auto-complete="off"
              placeholder="用户名"
              @keyup.enter.native="isLogin()"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              auto-complete="off"
              placeholder="密码"
              @keyup.enter.native="isLogin()"
            ></el-input>
          </el-form-item>
          <!--<el-form-item prop="identify">
						<el-col :span="8">
						    <el-input class="login-page-item" type="text" auto-complete="off" placeholder="验证码"></el-input>
						</el-col>
						<el-col :span="8">

						</el-col>
						<el-col :span="8">
						    <a class="identify-change">看不清，换一张</a>
						</el-col>
					</el-form-item>-->
          <el-checkbox class="rememberme">记住密码</el-checkbox>
          <el-form-item style="width:100%;">
            <el-button class="oldprimary" style="width:100%;" @click="isLogin">登&nbsp;&nbsp;录</el-button>
          </el-form-item>
          <div class="login-register">
            <a class="login-register-content" href="#" @click="toRegister">没有账号？马上注册</a>
            <!--<img class="login-register-img" src="../assets/images/login/register-go.png">-->
          </div>
        </el-form>
      </div>
      <div class="login-line"></div>
      <div class="login-hint">
        <p class="hint-title">温馨提示</p>
        <ul class="hint-content">
          <li>
            首次使用本平台
            <p class="item-content">请先注册新用户，通过注册用户名申请代理资格，而后就可代理天智旗下所有产品了</p>
          </li>
          <li>
            注册过用户名
            <p class="item-content">请通过您的用户名、密码登录本平台，在控制台里进行代理商资格申请</p>
          </li>
          <li>
            已经成为代理商
            <p class="item-content">请登录本平台进行产品的渠道销售</p>
          </li>
        </ul>
        <div class="hint-line"></div>
        <p class="item-content">渠道投诉：18611701033（白经理）&nbsp;&nbsp;&nbsp;&nbsp;投诉邮箱：bhw@tizdata.com</p>
      </div>
    </div>
    <!--登录end-->

    <img class="bg-bottom" src="../assets/images/login/bg-bottom.png" />
  </div>
</template>

<script>
import { requseLogin } from '../axios/api';
import { login } from '@/api/user';
export default {
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: '',
        rePassword: '',
      },
      loginRules: {
        username: [
          {
            required: true,
            message: '用户名不能为空',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    isLogin() {
      if (this.loginForm.username === '') {
        this.$message({
          type: 'error',
          message: '用户名不能为空',
          showClose: true,
        });
      } else if (this.loginForm.password === '') {
        this.$message({
          type: 'error',
          message: '密码不能为空',
          showClose: true,
        });
      } else {
        this.$store.dispatch('user/resetToken');
        this.loading = true;
        this.$store
          .dispatch('user/login', this.loginForm)
          .then(() => {
            this.$router.replace('/companyInformation');
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    handleLogin() {
      this.$refs.AccountForm.validate((valid) => {
        if (valid) {
          this.logining = true;
          let loginParams = {
            username: this.loginForm.username,
            password: this.loginForm.password,
          };
          // 调用axios登录接口
          requseLogin(loginParams)
            .then((res) => {
              // debugger;
              this.logining = false;
              // 根据返回的code判断是否成功
              let { code, msg, user } = res.data;
              if (code === 200) {
                // elementui中提示组件
                this.$message({
                  type: 'success',
                  message: msg,
                });
                // 登陆成功，用户信息就保存在sessionStorage中
                sessionStorage.setItem('user', JSON.stringify(user));
                // 跳转到后台主页面
                console.log('this', this);
                this.$router.push({
                  path: '/companyInformation',
                });
              } else {
                this.$message({
                  type: 'error',
                  message: msg,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log('error submit!');
          return false;
        }
      });
    },
    reset() {
      this.$refs.AccountForm.resetFields();
    },

    toRegister() {
      this.$router.push('/register');
    },
  },
};
</script>

<style>
@import url('../assets/css/style.css');
.login-main {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
}

.login-container {
  margin: auto;
  margin-top: 65px;
  width: 915px;
  height: 452px;
  background: #fff;
}

.login-form {
  display: inline-block;
  float: left;
  width: 400px;
}

.identify-change {
  text-decoration: underline;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 44px;
  letter-spacing: 0px;
  color: #0090ee;
}

.login-page {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  width: 350px;
}

.login-page-item {
  height: 44px;
  line-height: 44px;
}

.login-register {
  margin: auto;
  margin-top: 30px;
  width: 150px;
  height: 13px;
  line-height: 13px;
}

.login-register-content {
  margin-left: 20px;
  float: left;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 13px;
  letter-spacing: 0px;
  color: #2989dd;
}

.login-register-img {
  margin-left: 10px;
  float: left;
  vertical-align: center;
  width: 7px;
  height: 12px;
  line-height: 13px;
  /*background-color: #0090ee;*/
}

.login-title {
  margin-bottom: 43px;
  font-size: 32px;
  line-height: 38px;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
}

.login-tishi {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #ff6462;
}

.login-line {
  float: left;
  width: 1px;
  height: 400px;
  background-image: linear-gradient(to top, #ffffff, #e6e6e6, #ffffff);
  opacity: 0.8;
}

.login-hint {
  margin-left: 65px;
  width: 400px;
  float: left;
}

.hint-title {
  margin-bottom: 25px;
  margin-left: -20px;
  font-size: 22px;
  letter-spacing: 0px;
  color: #333333;
}

.hint-content li {
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 35px;
  letter-spacing: 0px;
  color: #333333;
}

.item-content {
  font-size: 12px;
  line-height: 26px;
  letter-spacing: 0px;
  color: #808080;
}

.hint-line {
  margin-left: -20px;
  margin-bottom: 10px;
  width: 420px;
  height: 1px;
  background-color: #e6e6e6;
  opacity: 0.7;
}

.bg-bottom {
  position: absolute;
  height: 15%;
  bottom: 0px;
}

label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue